module.exports = __webpack_public_path__ + "img/legalServices-1.0fa4a708.png";